import {Calculator, Shield, Sparkles, Target} from 'lucide-react'
import Breadcrumbs from '@/components/Breadcrumbs'
import SectionHeading from '@/components/ui/SectionHeading'
import Seo from '@/components/Seo'
import { breadcrumbSchema } from '@/lib/schema'

const values = [
  { icon: Calculator, title: 'Precision First', text: 'Every formula is built on standard financial mathematics — the same amortization, compounding, and metal-weight equations used by banks and bullion dealers.' },
  { icon: Shield, title: 'Privacy by Design', text: 'All calculations run entirely in your browser. We never store, transmit, or sell your financial inputs.' },
  { icon: Sparkles, title: 'Built for Displaced Mint Users', text: 'When Intuit Mint shut down, millions lost their favorite budgeting tool. We built Mint Calculator to fill that gap with modern, fast, ad-light calculators.' },
  { icon: Target, title: 'Free, Forever', text: 'Every calculator on this site is free to use with no signup, paywall, or account required.' },
]

function About() {
  return (
    <>
      <Seo
        title="About Mint Calculator"
        description="Learn about Mint Calculator's mission to provide free, precise personal finance, loan, Web3 mint gas, and numismatic coin valuation calculators for the community left behind by Intuit Mint."
        path="/about"
        schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'About', path: '/about' }])}
      />
      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'About', path: '/about' }]} />
        <SectionHeading eyebrow="Our Story" title="About Mint Calculator" description="A free, no-nonsense calculator suite for budgeting, loans, crypto mint gas, and coin valuation." />

        <div className="mt-8 space-y-4 text-sm leading-relaxed text-slate-400">
          <p>
            Mint Calculator (www.mintcalculator.com) was created after Intuit officially discontinued Mint,
            leaving millions of users without a simple way to track budgets, plan loan payoffs, and understand
            their personal finances. We built a modern, fast, and completely free alternative focused purely on
            calculation accuracy — no bank-linking, no account required, no ads blocking your numbers.
          </p>
          <p>
            Beyond traditional personal finance, we also serve two growing but underserved audiences: Web3
            collectors who need to estimate NFT minting gas costs before committing ETH or SOL, and numismatic
            enthusiasts who want a fast way to separate a coin's raw melt value from its collector premium.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {values.map(v => (
            <div key={v.title} className="rounded-xl border border-slate-800 bg-slate-900/50 p-5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500/10 text-emerald-400">
                <v.icon className="h-4 w-4" />
              </span>
              <p className="mt-3 text-sm font-semibold text-slate-100">{v.title}</p>
              <p className="mt-1.5 text-sm text-slate-500">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default About
